import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SuivipaiementProfileLayout from './SuivipaiementProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import EleveService from '../../services/EleveService';
import SuivipaiementService from '../../services/SuivipaiementService';
import AnneescolaireService from '../../services/AnneescolaireService';

const ViewSuivipaiement = () => {
	const { id } = useParams();
	const [suivipaiement, setSuivipaiement] = useState(null);
	const [selectedDate, setSelectedDate] = useState(null);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [EleveOptions, setEleveOptions] = useState([]);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);

				const Eleves = await EleveService.getEleveOptions();
				setEleveOptions(Eleves);
			} catch (error) {
				console.error('Erreur lors de la récupération des données:', error);
				// Replace the native alert with a Bootstrap alert or a custom notification
				setAlertMessage(
					`Erreur lors de la récupération des données. Détails de l'erreur : ${error.message}`
				);
				setShowAlert(true);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		Promise.all([
			SuivipaiementService.getSuivipaiement(id),
			AnneescolaireService.getCurrentAnneescolaire()
		]).then(([paiementData]) => {
			setSuivipaiement(paiementData.data);
			if (paiementData && paiementData.data) {
				const defaultDate = new Date(paiementData.data.date_paiement)
					.toISOString()
					.split('T')[0];
				setSelectedDate(defaultDate);
			}
		});
	}, [id]);

	const handleCheckboxChange = (name, value) => {
		setSuivipaiement((prevState) => ({ ...prevState, [name]: value }));
		setFeedbackMessages((prevMessages) => ({
			...prevMessages,
			[name]: value ? '' : ''
		}));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const suivipaiementData = new FormData();

				// Add all your form data to the FormData
				suivipaiementData.append('montant_paye', form.montant_paye.value);
				suivipaiementData.append(
					'tenue_classe_payee',
					form.tenue_classe_payee.checked
				);
				suivipaiementData.append('pull_payee', form.pull_payee.checked);
				suivipaiementData.append(
					'tenue_sport_payee',
					form.tenue_sport_payee.checked
				);
				suivipaiementData.append('date_paiement', form.date_paiement.value);
				suivipaiementData.append('anneescolaire', currentSchoolYear.id);

				// Call the EleveService to create the eleve
				const response = await SuivipaiementService.updateSuivipaiement(
					id,
					suivipaiementData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations du paiement',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<SuivipaiementProfileLayout>
			{suivipaiement && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}
								<Row>
									{/* tenue_sport_payee */}
									<Col xs={12}>
										<Form.Group className="mb-3">
											<Form.Check
												name="tenue_sport_payee"
												type="checkbox"
												id="tenue_sport_payee"
												label="Tenue de Sport"
												checked={suivipaiement.tenue_sport_payee}
												isInvalid={!!feedbackMessages['tenue_sport_payee']}
												onChange={(e) =>
													handleCheckboxChange(
														'tenue_sport_payee',
														e.target.checked
													)
												}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['tenue_sport_payee']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* tenue_classe_payee */}
									<Col xs={12}>
										<Form.Group className="mb-3">
											<Form.Check
												name="tenue_classe_payee"
												type="checkbox"
												id="tenue_classe_payee"
												label="Tenue de Classe"
												checked={suivipaiement.tenue_classe_payee}
												isInvalid={!!feedbackMessages['tenue_classe_payee']}
												onChange={(e) =>
													handleCheckboxChange(
														'tenue_classe_payee',
														e.target.checked
													)
												}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['tenue_classe_payee']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* pull_payee */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Check
												name="pull_payee"
												type="checkbox"
												id="pull_payee"
												label="Pull"
												checked={suivipaiement.pull_payee}
												isInvalid={!!feedbackMessages['pull_payee']}
												onChange={(e) =>
													handleCheckboxChange('pull_payee', e.target.checked)
												}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['pull_payee']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Montan restant */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="montant_paye">
												Montant versé <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="montant_paye"
												type="number"
												required
												placeholder="Saisir le montant versé "
												id="montant_paye"
												defaultValue={suivipaiement.montant_paye}
												isInvalid={!!feedbackMessages['montant_paye']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														montant_paye: e.target.value
															? ''
															: 'Le montant versé est requis.'
													}));
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['montant_paye']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* date_paiement */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="date_paiement">
												Date de Paiement <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="date_paiement"
												type="date"
												required
												defaultValue={selectedDate}
												placeholder="Saisir la Date de Paiement"
												id="date_paiement"
												isInvalid={!!feedbackMessages['date_paiement']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														type: e.target.value
															? ''
															: 'La Date de Paiement est requise'
													}));
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_paiement']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Enregistrer
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</SuivipaiementProfileLayout>
	);
};

export default ViewSuivipaiement;
